<template>
  <div class="w-full max-w-[420px] mx-auto">
    <div class="w-36 mx-auto z-0 relative top-1.5">
      <img class="w-full" src="/cloud-inactive.svg" alt="" />
      <Transition name="fade">
        <img v-if="status?.isOnline && !loading" class="w-full absolute top-0" src="/cloud-active.svg" alt="" />
      </Transition>
    </div>
    <div class="w-[69%] mx-auto relative z-10">
      <img class="w-full" src="/gateway-network/background.svg" alt="" />
      <Transition name="fade">
        <img
          v-if="status?.cellularActive && !loading"
          class="w-full absolute top-0 left-0 right-0"
          src="/gateway-network/left-active.svg"
          alt=""
        />
      </Transition>
      <Transition name="fade">
        <img
          v-if="status?.ethernetActive && !loading"
          class="w-full absolute top-0 left-0 right-0"
          src="/gateway-network/center-active.svg"
          alt=""
        />
      </Transition>
      <Transition name="fade">
        <img
          v-if="status?.wifiActive && !loading"
          class="w-full absolute top-0 left-0 right-0"
          src="/gateway-network/right-active.svg"
          alt=""
        />
      </Transition>
    </div>
    <div class="network-interface-container">
      <div class="network-interface" :class="{ active: status?.cellularCloudConnected }">
        <i :class="status?.cellularIcon"></i>
        <div class="title">Cellular</div>
        <div>{{ !status?.cellularCloudConnected ? 'Disconnected' : networkOperator }}</div>
      </div>
      <div
        class="network-interface"
        :class="{ active: status?.ethernetActive || (status?.ethernetUp && status.ethernetValidIP) }"
      >
        <i class="icon-ethernet"></i>
        <div class="title">Ethernet</div>
        <div>{{ status?.ethernetActive ? 'Connected' : 'Disconnected' }}</div>
      </div>
      <div class="network-interface" :class="{ active: status?.wifiActive || (status?.wifiUp && status.wifiValidIP) }">
        <i class="icon-wifi"></i>
        <div class="title">WiFi</div>
        <div>{{ status?.wifiActive ? 'Connected' : 'Disconnected' }}</div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { IGatewayConnectionStatus } from '@ncss/models';
import { computed } from 'vue';

export interface EnhancedGatewayConnectionStatus extends IGatewayConnectionStatus {
  ethernetUp?: boolean;
  ethernetValidIP?: boolean;
  wifiUp?: boolean;
  wifiValidIP?: boolean;
  cellularCloudConnected?: boolean;
}

const props = defineProps<{
  status?: EnhancedGatewayConnectionStatus;
  loading?: boolean;
}>();

const networkOperator = computed(() => {
  return !props.status?.networkOperator || props.status.networkOperator.toLowerCase() === 'unknown'
    ? 'Connected'
    : props.status.networkOperator;
});
</script>

<style scoped>
.network-interface-container {
  @apply grid grid-cols-3 mx-auto w-full;
}

.network-interface {
  @apply text-center py-1 text-gray-500 text-sm;
}

.network-interface i {
  @apply text-4xl transition-colors;
}

.network-interface .title {
  @apply text-base font-semibold transition-colors;
}

.network-interface.active i {
  @apply text-blue-500;
}

.network-interface.active .title {
  @apply text-gray-700;
}
</style>
